
import Vue from 'vue'
import ApiHttpService from '@/core/http/api.http.service'
import { IField, IMessage } from '@/core/models/results.interface'
import { VALIDACAO_INICIAL } from './util'

export default Vue.extend({
  name: 'CriarContaComponent',
  data() {
    return {
      loading: false,
      model: {
        nome: '',
        cpf: '',
        email: '',
        celular: '',
        senha: '',
        nascimento: '',
        termoAceite: false
      },
      validacao: VALIDACAO_INICIAL
    }
  },
  computed: {
    desabilitarBtnCadastro(): boolean {
      const regra1 = this.model.nome === ''
      const regra2 = this.model.cpf === ''
      const regra3 = this.model.email === ''
      const regra4 = this.model.celular === ''
      const regra5 = this.model.senha === ''
      const regra6 = !this.model.termoAceite

      return regra1 || regra2 || regra3 || regra4 || regra5 || regra6;
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    phoneMask(): string {
      const len = this.model.celular.length;
      return len === 15 ? '(##) #####-####' : '(##) ####-####'
    }
  },
  methods: {
    aoLimparValidacao() {
      this.validacao = Object.assign({}, VALIDACAO_INICIAL);
    },
    aoCriarValidacao(fields: IField[]) {
      this.aoLimparValidacao();

      fields.forEach(x => {

        const key = x.id;
        const message = x.message as IMessage;

        this.validacao[key as keyof typeof this.validacao] = {
          id: key,
          mensagem: message.text || '',
          error: true
        }
      });
    },
    aoLimparModel() {
      this.aoLimparValidacao();

      this.model = {
        nome: '',
        cpf: '',
        nascimento: '',
        email: '',
        celular: '',
        senha: '',
        termoAceite: false
      }
    },
    aoCriarConta() {
      this.loading = true;
      ApiHttpService.post<any>(`/usuario/cadastro`, this.model).then(result => {
        if (result.success) {
          this.aoLimparModel();
          this.$toast.info(`Cadastro realizado com sucesso!`);
          this.aoVoltarLogin();
        } else {
          this.aoCriarValidacao(result.fields);
          this.$toast.warning(`Por favor revise os campos para prosseguir.`)
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    aoVoltarLogin() {
      this.aoLimparModel();
      this.$emit(`step`, 1);
    }
  }
})
